export const getTasksListPath = (userGroupId: string) => {
  return `/user_groups/${userGroupId}/tasks`;
};

export const getDashboardTasksListPath = (companyId: string) => {
  return `/companies/${companyId}/tasks`;
};

export const taskItemResourceType = "task" as const;
